export const formatPrice = (num) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(num/100);
    // return `$${parseFloat((num/100).toFixed(2))}`;
}

export const getUniqueValues = (data, type) => {
    let unique = data.map((item)=>item[type]);
    if (type === 'colors' ){
        unique = unique.flat();
    }
    return ['all', ...new Set (unique)];
}
